import { threeDStudioStore } from 'Pods/ThreeDStudio/Store/index'

import { buildCanonicalParams } from './buildCanonicalParams'
import { getStoreValueForParam } from './getStoreValueForParam'

export const buildGeneratePayload = (settingsKey, schema, additionalPayloadData) => {
  if (!schema) {
    throw new Error('No model schema found')
  }

  const state = threeDStudioStore.getState()
  const properties = schema.input_schema?.properties || {}
  const canonicalParams = buildCanonicalParams(
    schema,
    key => getStoreValueForParam(key, settingsKey, state, properties),
  )

  return {
    data: {
      model_id: schema.model_id,
      run_type: 'model_generation',
      ...additionalPayloadData,
      canonical_params: canonicalParams,
    },
  }
}
